import { type ReactNode } from 'react';
import {
  MEMBER_COLOR_PALETTE,
  type PaletteEntry,
} from '@/utils/member-color';

type Props = {
  value: string;
  onChange: (next: string) => void;
};

const SWATCH_BASE =
  'group relative flex h-9 w-9 items-center justify-center rounded-full border transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface';

function swatchClass(active: boolean): string {
  return active
    ? `${SWATCH_BASE} border-white/70 scale-110 ring-1 ring-white/30`
    : `${SWATCH_BASE} border-white/[0.08] hover:border-white/40`;
}

type SwatchProps = {
  entry: PaletteEntry;
  active: boolean;
  onSelect: () => void;
};

function Swatch({ entry, active, onSelect }: SwatchProps): ReactNode {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-label={entry.label}
      aria-pressed={active}
      title={entry.label}
      style={{ backgroundColor: entry.value }}
      className={swatchClass(active)}
    >
      {active && <span className="text-xs font-bold text-void">✓</span>}
    </button>
  );
}

export function ColorPicker({ value, onChange }: Props): ReactNode {
  return (
    <div className="flex flex-wrap gap-sm" role="radiogroup">
      {MEMBER_COLOR_PALETTE.map((entry) => (
        <Swatch
          key={entry.id}
          entry={entry}
          active={entry.value.toLowerCase() === value.toLowerCase()}
          onSelect={() => onChange(entry.value)}
        />
      ))}
    </div>
  );
}
